
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <div className="mb-4">
              <img 
                src="https://static.readdy.ai/image/6b096200d48de7cb5be3c2123a55bd60/02fcb7bd67b34850874869ad200c7629.png" 
                alt="코이링크 | AiLink" 
                className="h-16 w-auto object-contain"
              />
            </div>
            <h4 className="text-xl font-semibold mb-4">
              일한연애 동반케어
            </h4>
            <p className="text-gray-400 leading-relaxed mb-6">
              일본인 여성과의 진정한 연애를 꿈꾸는 한국 남성들을 위한<br />
              세계 유일의 전문 동반 지원 서비스입니다.
            </p>
            <div className="space-y-2">
              <div className="text-gray-400">
                <p className="mb-1">회사명 : 주식회사 카부토</p>
                <p className="mb-1">代表: akihiro nakayama</p>
                <p className="mb-1">주소 : 오사카부 오사카시 키타구 우메다1-1-3 오사카역 앞 제3빌딩 29층 1-1-1호실</p>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-blue-400 mr-3"></i>
                <span className="text-gray-400">kabuto.co.ltd@gmail.com</span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line text-blue-400 mr-3"></i>
                <span className="text-gray-400">09082986698</span>
              </div>
              <div className="mt-4">
                <a 
                  href="/privacy" 
                  className="text-blue-400 hover:text-blue-300 underline cursor-pointer"
                  onClick={(e) => {
                    e.preventDefault();
                    window.REACT_APP_NAVIGATE('/privacy');
                  }}
                >
                  개인정보처리방침
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400">
            © 2024 일한연애 동반케어. All rights reserved.
          </p>
          <p className="text-sm text-gray-500 mt-2">
            <a href="https://readdy.ai/?origin=logo" className="text-gray-500 hover:text-gray-400">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
